import { useMutation, useQueryClient } from "react-query";
import axios from "axios";

const addUserEmail = async ({ userId, email }) => {
  let pathAndHost = window.location.protocol + window.location.host;
  let url = new URL(`/api/v2/users/${userId}/emails`, pathAndHost);
  let result;
  try {
    result = await axios.post(url.toString(), { email: email });
  } catch (err) {
    throw err;
  }
  return result.data;
};

export default function useAddUserEmail() {
  const queryClient = useQueryClient();
  return useMutation(async ({ userId, email }) => await addUserEmail({ userId, email }), {
    onMutate: async ({ email, userId }) => {
      await queryClient.cancelQueries(["users", userId, "emails"]);
      let previousUserEmails = queryClient.getQueryData(["users", userId, "emails"]);
      const previousUserEmailsClone = JSON.parse(JSON.stringify(previousUserEmails));
      const optimisticUserEmails = previousUserEmails;
      optimisticUserEmails.push({
        email: email,
        verified: false,
        is_primary: false,
      });
      queryClient.setQueryData(["users", userId, "emails"], optimisticUserEmails);
      previousUserEmails = previousUserEmailsClone;
      return {
        previousUserEmails,
        userId,
      };
    },
    onError: (err, userEmail, context) => {
      queryClient.setQueryData(["users", context.userId, "emails"], context.previousUserEmails);
    },
    onSettled: (data, err) => {
      if (err) {
        return;
      }
      if (data && data.email) {
        queryClient.invalidateQueries(["users", data.user_id, "emails"]);
      }
    }
  });
}
